<template>
  <v-dialog
    :value="showResultsLoadingModal"
    persistent
    max-width="600"
  >
    <v-card>
      <v-container
        fluid
        class="text-center d-flex flex-column justify-center align-center pa-8 pt-4"
      >
        <p
          class="navy-dark--text mt-6 mb-2"
          :class="$vuetify.breakpoint.mdAndDown ? 'title': 'display-1'"
        >
          {{ loadingMessage }}
        </p>
        <p
          class="navy-light--text mb-0"
          :class="$vuetify.breakpoint.mdAndDown ? 'body-1': 'title'"
          v-html="contentMessage"
        />
        <img
          v-if="hasActivePromotion"
          class="promo-image"
          :src="require('@/assets/images/FishermanRodToy.png')"
          alt="Fisherman Rod Toy"
          rel="preload"
        >
        <div
          class="dark-circle white--text
            d-flex justify-center align-center
            display-1 elevation-4 my-6"
        >
          <div data-unit-test="quoting-percentage">
            {{ quotingDonePercentage || 0 }}<span class="title">%</span>
          </div>
        </div>
        <v-progress-linear
          :value="quotingDonePercentage"
          :height="24"
          rounded
          color="primary"
        />

        <slot name="loading-details" />
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'results-loading-modal',
  inject: ['config', 'productName', 'constants'],
  props: {
    isQuotesLoading: {
      type: Boolean,
      required: true,
    },
    hasSucceededQuotes: {
      type: Boolean,
      required: true,
    },
    quotingDonePercentage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    showResultsLoadingModal () {
      return !this.hasSucceededQuotes && this.isQuotesLoading;
    },
    isCNIPartner () {
      return this.config.partner === this.constants.CNI_PARTNER;
    },
    loadingMessage () {
      if (this.isCNIPartner) {
        return 'Relax while we fish out your quotes…';
      }
      return 'Relax while we fetch your quotes…';
    },
    hasActivePromotion () {
      return this.isCNIPartner &&
        ['car', 'van', 'home', 'bike', 'pet'].includes(this.productName);
    },
    contentMessage () {
      if (this.hasActivePromotion) {
        return 'Purchase a policy and get a free <strong>Fisherman Rod Toy</strong>';
      }
      return `Searching the market for the best deals on ${this.productName} insurance`;
    },
  },
};
</script>

<style scoped>
.promo-image {
  max-width: 300px;
}
</style>
<style lang="scss" src='@/assets/scss/results/core-component.scss'></style>
